import Vue from 'vue'
import Vuex from 'vuex'
import db from '@/api/db'
import { setToken, getToken } from '@/libs/util'
import {getTemplate} from '@/api/func.js'
Vue.use(Vuex)
/*
项目列表 1
项目详情 2
新闻列表 3
新闻详情 4
捐赠列表 5
*/
//配置导航
// function getTemplate (value) {
//     let param = {};
//     switch (Number(value)) {
//         case 1:
//             param.path = "/project";
//             param.name = "project";
//         break;
//         case 2:
//             param.path = "/projectInfo";
//             param.name = "projectInfo";
//         break;
//         case 3:
//             param.path = "/dynamics";
//             param.name = "dynamics";
//         break;
//         case 4:
//             param.path = "/overView";
//             param.name = "overView";
//         break;
//         case 5:
//             param.path = "/donation"; 
//             param.name = "donation" ;
//         break;
//         default:
//             param.path = "/";
//             param.name = "home";
//     }
//     return param;
// }
export default new Vuex.Store({
     
       
    // 定义状态
    state: {
      /**
       * user 对象 -- 我的业务需求只需要缓存user对象即可
       */
      channelList:[],//导航列表
      webconfigInfo:{},//底部网站配置
      channelId:null,
      webInfo:getToken("webInfo"),
      style:0
    },
    mutations: {  
        setChannelList(state,data) {
            state.channelList = data 
        },
        setWebconfigInfo(state,data) {
            state.webconfigInfo = data 
        },
        setWebInfo(state,data){
            state.webInfo = data
            setToken(data,"webInfo")
        },
    },
    actions: {
        getChannelList({commit}){
            let channelList = this.state.channelList
            if(Object.keys(channelList).length != 0){
                return this.state.channelList
            }else{
                return  db.get(db.config.channel.list+'?result_type=tree').then(resp=>{
                    resp.data.forEach((item, index) => {
                        let str = getTemplate(item.template,item);
                        resp.data[index].path = str.path;
                        resp.data[index].name = str.name;
                        resp.data[index].activeSelect = false;
                        if (item.children) {
                          item.children.forEach((item1, index1) => {
                            let param = getTemplate(item1.template,item1);
                            item.children[index1].path = param.path;
                            item.children[index1].name = param.name;
                            item.children[index1].activeSelect = false;
                          });
                        }
                    }) 
                    const data = resp.data
                    commit('setChannelList',data) 
                    return resp.data
                }).catch(err => {
                    console.log(err);
                  });
            }    
        },
        getWebconfigInfo({commit}){
            let webconfigInfo = this.state.webconfigInfo
            if(Object.keys(webconfigInfo).length != 0){
                return this.state.webconfigInfo
            }else{
                return  db.get(db.config.webconfigInfo).then(resp=>{
                    const data = resp.data
                    commit('setWebconfigInfo',data) 
                    return resp.data
                }).catch(err => {
                    console.log(err);
                  });
            }
        }
    }
    
  });
  
 
  


// WEBPACK FOOTER //
// ./src/store/index.js